import React, { Component } from "react";
import { Wrapper, Row, KeyboardView, Container, Copy } from "app/NativeComponents/common";
import { NewHeader, SearchBar, InlineButton, List, SelectItem } from "app/NativeComponents/snippets";
import { connect } from "react-redux";
import { popSidePanel } from "app/NativeActions";

class SelectExportColumns extends Component {
  constructor(props) {
    super(props);

    const panel_data = props.device === "mobile"
      ? props?.route?.params?.panel_data
      : props.panel_data;

    this.state = {
      column_search: panel_data?.column_search || "",
      list_columns: panel_data?.list_columns || [],
      column_export_objects: [],
      opened_column_menus: [],
      export_type: panel_data?.export_type || ""
    };
  }

  componentDidMount() {
    this.filterExportColumns(this.state.list_columns);
  }

  handleBack = () => {
    this.props.popSidePanel();
  };

  updateOpenedColumnMenus = (opened_column_menus) => {
    this.setState({ opened_column_menus });
  };

  filterExportColumns = (items) => {
    const { export_type, column_search } = this.state;

    // preserve incoming order (already matches registry order from backend)
    const matchesSearch = (item) =>
      !column_search ||
      (item.title || "").toLowerCase().includes(column_search.toLowerCase());

    const filteredItems = items.filter(matchesSearch); // keeps order

    if (export_type === "contacts") {
      // fixed group order for contacts
      const groupsInOrder = [
        { export_group_slug: "contact_info", title: "Contact Info", items: [] },
        { export_group_slug: "property_info", title: "Property Info", items: [] },
        { export_group_slug: "lead_info", title: "Lead Info", items: [] },
        { export_group_slug: "custom_fields_info", title: "Custom Fields", items: [] },
      ];

      // fill groups without re-sorting within group
      filteredItems.forEach((it) => {
        const idx = groupsInOrder.findIndex(g => g.export_group_slug === it.export_group_slug);
        if (idx !== -1) groupsInOrder[idx].items.push(it);
      });

      // only keep non-empty groups
      const nonEmpty = groupsInOrder.filter(g => g.items.length > 0);
      this.setState({ column_export_objects: nonEmpty });
    } else {
      // no grouping, no sorting — just the flat list in original order
      this.setState({
        column_export_objects: [
          { export_group_slug: "property_info", title: "Property Info", items: filteredItems },
        ]
      });
    }
  };


  toggleColumnGroup = (export_group_slug) => {
    const opened_column_menus = [...this.state.opened_column_menus];
    const index = opened_column_menus.indexOf(export_group_slug);

    if (index > -1) {
      opened_column_menus.splice(index, 1);
    } else {
      opened_column_menus.push(export_group_slug);
    }

    this.updateOpenedColumnMenus(opened_column_menus);
  };

  toggleAllSelection = (selectAll) => {
    this.setState({
      list_columns: this.state.list_columns.map(column => ({
        ...column,
        export: selectAll
      }))
    }, () => {
      this.filterExportColumns(this.state.list_columns);
    });
    this.getPanelData()?.setIncludeAllColumns(selectAll);

  };

  toggleGroupSelection = (export_group_slug, selectAll) => {
    this.setState((prevState) => ({
      list_columns: prevState.list_columns.map((column) =>
        column.export_group_slug === export_group_slug
          ? {
            ...column,
            export: column.default ? true : selectAll, // keep defaults always true
          }
          : column
      ),
    }), () => {
      this.filterExportColumns(this.state.list_columns);
    });
  };

  renderColumnItems = (items, export_group_slug) => {
    if (!this.state.opened_column_menus?.includes(export_group_slug)) {
      return null;
    }

    return (
      <Wrapper>
        <Row style={{ paddingHorizontal: 10, paddingVertical: 5 }}>
          <InlineButton
            onPress={() => this.toggleGroupSelection(export_group_slug, true)}
            style={{ marginLeft: 0 }}
          >
            Select All
          </InlineButton>
          <InlineButton
            onPress={() => this.toggleGroupSelection(export_group_slug, false)}
            style={{ marginLeft: 10 }}
          >
            Clear All
          </InlineButton>
        </Row>
        {items.map((item) => (
          <SelectItem
            key={item.slug}
            disableHover={item.default}
            selected={!!item.export || item.default}
            onPress={item.default ? null : () => this.checkListItem(item)}
            select_type={item.default ? "icon" : "check"}
            select_icon={item.default ? "lock" : null}
            select_disabled={item.default}
            subtext={item.default ? "Default Column" : ""}
          >
            {item.title}
          </SelectItem>
        ))}
      </Wrapper>
    );
  };

  renderColumnGroups = (item, index) => {
    const isOpen = this.state.opened_column_menus?.includes(item.export_group_slug);
    const selectedCount = item.items.filter(column => column.export && !column.default).length;
    const totalCount = item.items.filter(column => !column.default).length;
    const defaultCount = item.items.filter(column => column.default).length;
    return (
      <Wrapper key={"trigger_" + index}>
        <SelectItem
          onPress={() => this.toggleColumnGroup(item.export_group_slug)}
          selected={isOpen}
          subtext={`${selectedCount}/${totalCount} selected ${defaultCount > 0 ? `+ ${defaultCount} ${defaultCount > 1 ? "defaults" : "default"}` : ""}`}
          select_type="none"
          icon={isOpen ? "keyboard-arrow-up" : "keyboard-arrow-down"}
          renderBottom={() => this.renderColumnItems(item.items, item.export_group_slug)}
        >
          {item.title}
        </SelectItem>
      </Wrapper>
    );
  };

  checkIfNeedsToSave = () => {
    const panel_data = this.props.device === "mobile"
      ? this.props?.route?.params?.panel_data
      : this.props.panel_data;

    const initialColumns = panel_data?.list_columns || [];
    const currentColumns = this.state.list_columns || [];

    const initialSelected = initialColumns
      .filter(col => col.export || col.default)
      .map(col => col.slug);
    const currentSelected = currentColumns
      .filter(col => col.export || col.default)
      .map(col => col.slug);

    return (
      (initialSelected.length !== currentSelected.length ||
        !initialSelected.every(slug => currentSelected.includes(slug))) && currentSelected.length > 0
    );
  };

  checkListItem = (item) => {

    this.setState((prevState) => ({
      list_columns: prevState.list_columns.map((column) =>
        column.slug === item.slug
          ? { ...column, export: !column.export || column.default }
          : column
      ),
    }), () => {
      // Update column_export_objects after state change
      this.filterExportColumns(this.state.list_columns);
    });
  };


  handleSave = () => {
    const selectedColumns = this.state.list_columns.filter(column => column.export || column.default);
    const listColumns = this.state.list_columns;
    const panel_data = this.getPanelData();

    if (panel_data?.onSave) {
      panel_data.onSave(selectedColumns, listColumns);

      const allSelected = listColumns.every(col => col.export || col.default);
      panel_data.setIncludeAllColumns(allSelected);
    }
    this.props.popSidePanel();
  };

  getPanelData = () => {
    return this.props.device === "mobile"
      ? this.props?.route?.params?.panel_data
      : this.props.panel_data;
  };

  getSelectedCount = () => {
    return this.state.list_columns.filter(column => column.export || column.default).length;
  };

  getTotalCount = () => {
    return this.state.list_columns.length;
  };

  render() {

    const selectedCount = this.getSelectedCount();
    const totalCount = this.getTotalCount();

    return (
      <Container>
        <NewHeader
          title="Select Columns to Export"
          subtitle={`${selectedCount}/${totalCount} columns selected`}
          leftButton={{
            icon: "arrow-back",
            onPress: this.handleBack
          }}
        />
        <SearchBar
          style={{ margin: 10 }}
          title="Search"
          value={this.state.column_search}
          onChange={value => {
            this.setState({ column_search: value }, () => {
              this.filterExportColumns(this.state.list_columns);
            });
          }}
        />
        <Row style={{ paddingHorizontal: 10, paddingVertical: 5 }}>
          <InlineButton onPress={() => this.toggleAllSelection(true)}>
            Select All ({totalCount})
          </InlineButton>
          <InlineButton onPress={() => this.toggleAllSelection(false)}>
            Clear All
          </InlineButton>
          <Wrapper style={{ marginLeft: "auto" }}>
            <InlineButton
              disabled={!this.checkIfNeedsToSave()}
              onPress={this.handleSave}
            >
              Save &amp; Close
            </InlineButton>
          </Wrapper>
        </Row>
        <KeyboardView style={{ flex: 1 }}>
          {this.state.column_export_objects.length === 0 && this.state.column_search ? (
            <Wrapper style={{ padding: 20, alignItems: "center", justifyContent: "center" }}>
              <Copy>No columns found matching "{this.state.column_search}"</Copy>
            </Wrapper>
          ) : (
            <List
              items={this.state.column_export_objects}
              itemStructure={({ item, index }) => this.renderColumnGroups(item, index)}
            />
          )}
        </KeyboardView>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, native, settings }) => {
  const { token, user } = auth;
  const { device } = native;
  const { colors, dark_mode } = settings;

  return {
    token,
    user,
    device,
    colors,
    dark_mode
  };
};

export default connect(mapStateToProps, {
  popSidePanel
})(SelectExportColumns);